import { createServerFn } from "@tanstack/react-start";
import { publicClient } from "@/lib/mobile-api.server";

export interface GlossaryEntry {
  slug: string;
  term: string;
  essence: string | null;
  definition: string;
  cluster: string | null;
  /** Canonical destination for the full entry. */
  path: string;
}

/** Codex concepts, alphabetised, used as the site's canonical glossary. */
export const getGlossary = createServerFn({ method: "GET" }).handler(
  async (): Promise<GlossaryEntry[]> => {
    const supabase = publicClient();
    const { data, error } = await supabase
      .from("codex_concepts")
      .select("slug, title, essence, definition, cluster")
      .order("title", { ascending: true })
      .limit(1000);
    if (error) return [];
    return (data ?? []).map((c) => ({
      slug: c.slug,
      term: c.title,
      essence: c.essence ?? null,
      definition: c.definition,
      cluster: c.cluster ?? null,
      path: `/codex/${c.slug}`,
    }));
  },
);
